<template>
    <div>

    <!-- Modal -->
    <div class="modal fade" id="fornecedorModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Fornecedor/Prestador</h5>
                    <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <az-empty-state v-if="!item" />

                    <template v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="button-group"
                                    label="Pessoa"
                                    :optionsList="[
                                        { id: 'F', search: 'Fïsica' }, 
                                        { id: 'J', search: 'Jurídica' },
                                        { id: 'O', search: 'Outra' }
                                    ]"
                                    v-model="item.tipo_pessoa" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    :type="item.tipo_pessoa == 'F' ? 'cpf' : ( item.tipo_pessoa == 'O' ? '' : 'cnpj' )"
                                    :label="item.tipo_pessoa == 'F' ? 'CPF' : ( item.tipo_pessoa == 'O' ? 'Número' : 'CNPJ' ) "
                                    required 
                                    :validate="validate"
                                    v-model="item.st_cpf_cnpj" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    :label="item.tipo_pessoa == 'J' ? 'Nome Fantasia' : 'Nome'"
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome_fantasia" />
                            </div>
                            <div class="col col-12 col-md-6" v-if="item.tipo_pessoa == 'J'">
                                <az-input
                                    label="Razão Social"
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome_razao_social" />
                            </div>
                        </div>

                        <div class="row" v-if="item.tipo_pessoa == 'J'">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Inscrição Estadual"
                                    :validate="validate"
                                    v-model="item.st_inscricao_estadual" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Inscrição Municipal"
                                    :validate="validate"
                                    v-model="item.st_inscricao_municipal" />
                            </div>
                        </div>

                        <az-sub-title class="mt-2" title="Impostos" />

                        <impostos 
                            :impostos="impostos" 
                            :aliquotas="true"
                            :edicao="true"
                            v-model="item" />

                        <az-sub-title class="mt-2" title="Endereço" />
                        <cadastro-endereco :edicao="true" v-model="item.endereco" :validate="validate" />

                        <az-sub-title class="mt-2" title="Contato" />
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Contato"
                                    v-model="item.st_nome_contato" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Cargo"
                                    :edicao="!!item.st_nome_contato"
                                    v-model="item.st_cargo_contato" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Telefone"
                                    type="fone"
                                    :edicao="!!item.st_nome_contato"
                                    :validate="validate"
                                    v-model="item.st_telefone" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="e-mail 1"
                                    type="email"
                                    :validate="validate"
                                    v-model="item.st_email1" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="e-mail 2"
                                    type="email"
                                    :validate="validate"
                                    v-model="item.st_email2" />
                            </div>
                        </div>

                        <az-sub-title class="mt-2" title="Dados Bancários" />
                        <dados-bancarios v-model="item.dados_bancarios" :validate="validate" />

                        <template v-if="item.medicos && item.medicos.length">
                            <az-sub-title class="mt-2" title="Prestadores" />
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(medico, imx) in item.medicos" :key="imx">
                                    <a href="#" class="card-link" @click.prevent="$util.abrirMedico(medico)">
                                        {{ medico.st_nome_exibicao }}
                                    </a>
                                </li>
                            </ul>
                        </template>

                        <template v-else>
                            <az-sub-title class="mt-2" title="Compras" />
                            <div class="row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Valor Mínimo"
                                        type="money"
                                        :validate="validate"
                                        v-model="item.dc_valor_minimo" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Valor Máximo"
                                        type="money"
                                        :validate="validate"
                                        v-model="item.dc_valor_maximo" />
                                </div>
                            </div>

                            <az-sub-title class="mt-2" title="Categoria" />
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <selecao-categoria 
                                        v-model="item.id_categoria" 
                                        ch_tipo_lancamento="D"
                                        tipo_lista_categoria_default="L"
                                        block_tipo_lista_categoria22="L" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Centro de Custo"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="centro_custos.index"
                                        :optionsSync="true"
                                        :validate="validate"
                                        optionsData="id_centro_custo"
                                        v-model="item.id_centro_custo" />
                                </div>
                            </div>
                        </template>

                        <az-sub-title title="Classificações" />
                        <div class="form-row">
                            <div class="col col-12">
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação selecionada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div v-if="item.campos_customizados" class="row">
                            <div class="col col-12">
                                <az-sub-title :title="item.campos_customizados.st_titulo" />
                                <formulario 
                                    :gutters="true" 
                                    :validate="validate"
                                    v-model="item.campos_customizados.js_campos" 
                                    :saved="saved" 
                                    mode="fixed"
                                    :config="true" />
                            </div>
                        </div>

                        <div class="mt-3">
                            <sinalizador-gen-vinculo 
                                v-if="item.id_fornecedor"
                                :model="item" 
                                :model_id="item.id_fornecedor"
                                model_type="fornecedor"  />
                        </div>

                    </template>
                    
                </div>
                <div class="modal-footer" v-if="item">
                    <button class="btn btn-outline-primary mr-2" @click="abrir_anexos ()" v-if="item.id_fornecedor">
                        <i class="fa-solid fa-paperclip"></i>
                        <span class="badge badge-primary ml-1" v-if="item.arquivos && item.arquivos.length">
                            {{ item.arquivos.length }}
                        </span>
                    </button>
                    <az-audit-log-button model="fornecedor" :id="item.id_fornecedor" v-if="item && item.id_fornecedor" />
                    <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    <az-submit @click="atualizar ()">
                        {{ item && item.id_fornecedor ? 'Atualizar' : 'Incluir' }}
                    </az-submit>
                </div>
            </div>
        </div>
    </div>

    <!-- Envio de Arquivo -->
    <template v-if="acao_anexar && item && item.arquivos">
        <az-file-upload
            :tem_validade="true"
            ref="upload"
            @refresh="carregar_arquivos()"
            :multiple="true"
            :arquivos="item.arquivos"
            :parms="{ model_type: 'fornecedor', model_id: item.id_fornecedor }" />
    </template>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import DadosBancarios from '../../cadastros/shared/DadosBancarios.vue';
import Impostos from '../financeiro/Impostos.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Formulario from '../consultorio/Formulario.vue';
import SelecaoCategoria from './SelecaoCategoria.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import Multiselect from 'vue-multiselect';
import SinalizadorGenVinculo from '../../shared/SinalizadorGenVinculo.vue';

export default {
    data() { 
        return { 
            item: null, 
            validate: false, 
            impostos: [], 
            saved: true, 
            acao_anexar: false,
            options_classes: [], 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton,
        CadastroEndereco,
        DadosBancarios,
        Impostos,
        Formulario,
        SelecaoCategoria, 
        AzFileUpload, 
        Multiselect, 
        SinalizadorGenVinculo, 
    },

    props: ['suprimentos'], 

    methods: { 
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        carregar_arquivos(abrir = false) {
            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.item.id_fornecedor,
                    type: 'fornecedor',
                }
            })
            .then(res => {
                this.item.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                        this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });
        },

        abrir_anexos () {
            this.acao_anexar = true;

            if ( this.item.arquivos && this.item.arquivos.length
                && !this.item.arquivos.find(arq => arq.arquivo) ) {

                this.carregar_arquivos(true);
                return;

            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        //

        fechar_modal() { 
            $('#fornecedorModal').modal('hide'); 
        },

        incluir (tags = []) { 

            let item = { 
                id_fornecedor: null, 
                st_nome_razao_social: "", 
                st_nome_fantasia: "", 
                st_cpf_cnpj: "", 
                tipo_pessoa: "J",
                endereco: {}, 
                fl_ativo: true, 
                dados_bancarios: {
                    id_cadastro: null, 
                    id_banco: null, 
                    in_agencia: null, 
                    in_conta: null, 
                    ch_digito_conta: null, 
                    st_observacoes: null, 
                },
                medicos: [],
                retencoes: [], 
            };

            this.editar(item, tags);
            
        },

        editar (item, tags = []) { 

            this.item = null;
            this.validate = false;
            this.options_classes = _.cloneDeep(tags);

            this.$nextTick (() => { 

                if ( item.id_fornecedor ) { 

                    $('#fornecedorModal').modal('show'); 

                    this.$util.load(this, { 
                        service: 'fornecedores',
                        func: 'show',
                        parms: { 
                            id: item.id_fornecedor,
                            cadastro: true, 
                        },
                        loadTo: res => { 
                            this.item = res;

                            if ( !this.item.endereco ) { 
                                this.item.endereco = {};
                            }

                            if ( !this.item.dados_bancarios ) { 
                                this.item.dados_bancarios = {};
                            }
                        }
                    });

                    return;

                }

                this.item = _.cloneDeep(item);

                if ( !this.item.endereco ) { 
                    this.item.endereco = {};
                }

                if ( !this.item.dados_bancarios ) { 
                    this.item.dados_bancarios = {};
                }

                $('#fornecedorModal').modal('show'); 
            })

        },

        atualizar () { 
            this.$util.atualizar (this, { 
                service: 'fornecedores',
                dados: { 
                    ...this.item,  
                    suprimentos: this.suprimentos ? true : false, 
                }, 
                modal: 'fornecedorModal', 
                callback: () => { 
                    this.$util.resync(this, 'fornecedores.index');
                    this.$emit('refresh');
                }
            });
        },
    },

    mounted() { 

        if ( this.$store.state.contexto && this.$store.state.contexto.fornec_impostos ) { 

            this.impostos = this.$store.state.contexto.fornec_impostos;

        } else { 

            this.$util.loadItem(this, { 
                service: 'impostos',
                func: 'index',
                parms: { 
                    where: { 
                        fl_ativo: true, 
                        fl_a_receber: false 
                    },
                },
            })
            .then(res => { 
                this.impostos = res;

                this.$store.commit('setContexto', { fornec_impostos: res });
            });

        }

    }

}
</script>